import readStatus from "../../assets/svg/read-message.svg";
import sentStatus from "../../assets/svg/sent-message.svg";
import deliveredStatus from "../../assets/svg/delivered-message.svg";

type MessageStatusProps = {
  status: "sent" | "delivered" | "read";
};
export default function MessageStatus(props: MessageStatusProps) {
  let { status } = props;
  let statusIcon = sentStatus;
  if (status === "delivered") statusIcon = deliveredStatus;
  if (status === "read") statusIcon = readStatus;

  return <img src={statusIcon} alt="message status" />;
}
